/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Stat_PremiereInputs */

const en_fw_guide_stat_premiere = /** @type {(inputs: Fw_Guide_Stat_PremiereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TV premiere, 2026`)
};

const zh_fw_guide_stat_premiere = /** @type {(inputs: Fw_Guide_Stat_PremiereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2026 年电视首播`)
};

/**
* | output |
* | --- |
* | "TV premiere, 2026" |
*
* @param {Fw_Guide_Stat_PremiereInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_stat_premiere = /** @type {((inputs?: Fw_Guide_Stat_PremiereInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Stat_PremiereInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_stat_premiere(inputs)
	return zh_fw_guide_stat_premiere(inputs)
});
export { fw_guide_stat_premiere as "fw.guide.stat.premiere" }